import { ApplicationConfig, ProjectInfo } from '@frontend-site/shared/data';
import { MenuItem } from '../../../../models';
import { MENU_IDS } from '../../../menu-ids';
import { createOverviewSubMenu, showCustomDashboardMenu, showOrgOverviewMenu } from './overview-submenu-factory';

export function createOverviewMenu(
    projectInfo: ProjectInfo,
    appConfig: ApplicationConfig,
    legacyAppVersion: string | undefined,
    isForesightAllComponentsModuleNewUi: boolean,
    isUnifiedProjectPlanNewUi = false
): MenuItem {
    const submenu = createOverviewSubMenu(
        projectInfo,
        appConfig,
        legacyAppVersion,
        isForesightAllComponentsModuleNewUi,
        isUnifiedProjectPlanNewUi
    );

    if (showOrgOverviewMenu(projectInfo, appConfig)) {
        return createOrgOverviewMenu(projectInfo.id, submenu);
    }

    if (projectInfo.rdxEnabled || showCustomDashboardMenu(projectInfo)) {
        return createDashboardOverviewMenu(projectInfo, submenu);
    }

    if (shouldShowDefaultSfOverviewMenu(projectInfo, submenu)) {
        return createDefaultSfOverviewMenu(submenu);
    }

    // return default project overview
    return createProjectOverviewMenu(projectInfo, submenu);
}

function createOrgOverviewMenu(projectId: number, submenu?: MenuItem[]): MenuItem {
    return {
        id: MENU_IDS.PROJECT.OVERVIEW.DEFAULT,
        label: 'Enumerations.ApplicationModules.OVERVIEW_MENU.OVERVIEW',
        routePath: `/tm/${projectId}/project/organizationOverview`,
        menu: submenu
    };
}
function createDashboardOverviewMenu(projectInfo: ProjectInfo, submenu?: MenuItem[]): MenuItem {
    const defaultPath =
        projectInfo.isIcr3Project() && projectInfo.projectInProgress
            ? `${projectInfo.id}/projectPlan`
            : `/tm/${projectInfo.id}/project/customDashboard`;

    return {
        id: MENU_IDS.PROJECT.OVERVIEW.DEFAULT,
        label: 'Enumerations.ApplicationModules.OVERVIEW_MENU.OVERVIEW',
        routePath: defaultPath,
        menu: submenu
    };
}

function shouldShowDefaultSfOverviewMenu(projectInfo: ProjectInfo, submenu: MenuItem[]): boolean {
    return projectInfo.isSalesforceProject() && submenu?.length > 0;
}
function createDefaultSfOverviewMenu(submenu: MenuItem[]): MenuItem {
    return {
        id: MENU_IDS.PROJECT.OVERVIEW.DEFAULT,
        label: 'Enumerations.ApplicationModules.OVERVIEW_MENU.OVERVIEW',
        routePath: submenu[0].routePath,
        menu: submenu
    };
}
function createProjectOverviewMenu(projectInfo: ProjectInfo, submenu?: MenuItem[]): MenuItem {
    const defaultPath =
        projectInfo.isIcr3Project() && projectInfo.projectInProgress
            ? `${projectInfo.id}/projectPlan`
            : `/tm/${projectInfo.id}/project/dashboard`;
    return {
        id: MENU_IDS.PROJECT.OVERVIEW.DEFAULT,
        label: 'Enumerations.ApplicationModules.OVERVIEW_MENU.OVERVIEW',
        routePath: defaultPath,
        menu: submenu
    };
}
